import type { PublicService } from './content-api';

export const BOOKING_SERVICE_KEY='mf_booking_service';
export const BOOKING_SLOT_KEY='mf_booking_slot';
export const BOOKING_DETAILS_KEY='mf_booking_details';
export const BOOKING_REFERENCE_KEY='mf_booking_reference';
export const BOOKING_ID_KEY='mf_booking_id';
export const BOOKING_LOOK_KEY='mf_booking_look';

export type StoredService=Pick<PublicService,'id'|'slug'|'name'|'starting_price'|'price_suffix'|'duration_label'|'duration_minutes'|'deposit_percent'|'description'|'category'>;
export type StoredSlot={date:string;dateLabel:string};
export type StoredDetails={fullName:string;whatsapp:string;email?:string;inspiration?:string;shape:string;notes:string};

export function readStored<T>(key:string,fallback:T):T{try{const value=localStorage.getItem(key);return value?JSON.parse(value) as T:fallback}catch{return fallback}}
export function writeStored<T>(key:string,value:T){localStorage.setItem(key,JSON.stringify(value))}
export function clearBookingState(){[BOOKING_SERVICE_KEY,BOOKING_SLOT_KEY,BOOKING_DETAILS_KEY,BOOKING_REFERENCE_KEY,BOOKING_ID_KEY,BOOKING_LOOK_KEY].forEach(key=>localStorage.removeItem(key))}
